<template>
    <department-picker-new v-model="line.department" :ui="crTransUi" />
</template>

<script setup lang="ts">
import {TransactionEntryLine} from '@/types/transaction/TransactionEntryLine'
import DepartmentPickerNew from '@/dimensions/DepartmentPickerNew.vue'

const line = defineModel<TransactionEntryLine>({required: true})

const crTransUi = {
    content: 'z-1 min-w-fit bg-none',
    trailing: 'absolute right-0 pr-1 bg-none',
    base: 'rounded-none h-8 bg-transparent ring-base-300'
}

</script>

<style>
</style>